import * as React from 'react';
import * as style from './StepsTile.css';
import { IStep, TPage } from '../../types/helper';
import { STEPS } from '../../constants/page-content';
import { IconStep } from './icon/step';
import { mergeStyles } from '@cian/utils';

export interface IStepsTileProps {
  redirectPage(page: TPage): void;
}

export class StepsTile extends React.Component<IStepsTileProps, {}> {
  private handleClick = (page: TPage) => () => {
    this.props.redirectPage(page);
  }

  public render() {
    return <div className={style['steps_container']}>
      <div className={style['steps_row']}>
        {STEPS.map((step, index) => (
          <Step
            key={`s${index}`}
            step={step} stepNumber={index + 1}
            onClick={this.handleClick(step.page as TPage)}
          />
        ))}
      </div>
    </div>;
  }
}

interface IStepProps {
  step: IStep;
  stepNumber: number;
  onClick(): void;
}

const Step = (props: IStepProps) => (
  <div
    {...mergeStyles([
      style['steps_step'],
      style['steps_box'],
    ])}
    onClick={props.onClick}
  >
    <div className={style['steps_body']}>
      <div className={style['steps_title']}>{props.step.title}</div>
      {props.step.body}
    </div>
    <div className={style['steps_icon']}><IconStep step={props.stepNumber} /></div>
  </div>
)
